import { render, staticRenderFns } from "./CommissionPlanEdit.vue?vue&type=template&id=5450cff4&"
import script from "./CommissionPlanEdit.vue?vue&type=script&lang=js&"
export * from "./CommissionPlanEdit.vue?vue&type=script&lang=js&"
import style0 from "./CommissionPlanEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports